import EventEmitter from "./_EventEmitter";
var EventEmitter_default = EventEmitter;
export {
  EventEmitter_default as default
};
//# sourceMappingURL=EventEmitter.js.map
